import React from 'react';
import ErrorPage from '../ErrorPage';
import Layout, { withLayout } from '../Layout';
const Error = () => {
    const hdnTitle = document.getElementById('hdnTitle');
    let title;
    if (hdnTitle) {
        title = hdnTitle.value;
        hdnTitle.remove();
    }
    const hdnMessage = document.getElementById('hdnMessage');
    let message;
    if (hdnMessage) {
        message = hdnMessage.value;
        hdnMessage.remove();
    }
    return (React.createElement(Layout, { idModule: "", idPage: "", noPadding: true, noServer: true },
        React.createElement(ErrorPage, { errorTitle: title || '', errorType: "500", id: "ErrorPage", message: message || '', noHeader: true })));
};
const ErrorWithLayout = withLayout(Error);
export default ErrorWithLayout;
